import { useEffect, useRef, useState, } from "react";
import OuterPageHeader from '../Header/OuterPageHeader'
import {
    Box,
    Container,
    Typography,
    Button,
    Grid2,
    Avatar,
    Stack,
    Divider,
    Collapse,
} from "@mui/material";
import { ButtonIcons1, ButtonIcons2, ButtonIcons22, CheckIcons, CheckIcons2, CryptoClarityIcon, FaqIcons } from "../../../Svgcollectons";
import OuterPageFooter from "../Footer/OuterPageFooter";
import { useNavigate } from "react-router-dom";
import SectionBennerImg from "../../../Images/home/benner-section-img.webp";
import GradientBadge from "./GradientBadge";
import SectionTwoImg from "../../../Images/home/section-two-img.webp";
import SectionThreeImg from "../../../Images/home/section-three-img.webp";
import SectionThreeImg1 from "../../../Images/home/section-three-img1.webp";
import SectionThreeImg2 from "../../../Images/home/section-three-img2.webp";
import SectionFourImg from "../../../Images/home/section-four-img.webp";
import SectionFiveIcon1 from "../../../Images/home/section-five-icon1.webp";
import SectionFiveIcon2 from "../../../Images/home/section-five-icon2.webp";
import SectionFiveIcon3 from "../../../Images/home/section-five-icon3.webp";
import SectionSixImg1 from "../../../Images/home/section-six-img1.webp";
import SectionSixImg2 from "../../../Images/home/section-six-img2.webp";
import SectionSixImg3 from "../../../Images/home/section-six-img3.webp";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useDispatch, useSelector } from "react-redux";
import { getAssetsNoauth } from "../../../Actions/AssetsAction";
import useBinanceAllTickers from "../../../socket/BinanceMarketSocket";



const useCountUp = (end, duration = 2000) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        let start = 0;
        const step = end / (duration / 16);

        const timer = setInterval(() => {
            start += step;
            if (start >= end) {
                setCount(end);
                clearInterval(timer);
            } else {
                setCount(Math.floor(start));
            }
        }, 16);

        return () => clearInterval(timer);
    }, [end, duration]);

    return count;
};


const StatCard = ({ value, suffix, label }) => {
    const count = useCountUp(value);

    return (
        <Box
            sx={{
                position: "relative",
                background: "rgba(255,255,255,0.03)",
                borderRadius: "14px",
                p: 2.5,
                boxShadow: "0 10px 30px rgba(0,0,0,0.45)",
                overflow: "hidden",
                height: "-webkit-fill-available",
                transition: "transform 0.25s ease",

                "&::before": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    padding: "1px",
                    borderRadius: "14px",
                    background: `
        linear-gradient(
          180deg,
          rgba(222, 182, 90, 0.06) 0%,
          rgba(255, 255, 255, 0.00) 100%
        ),
        linear-gradient(
          89deg,
          rgba(190, 153, 72, 0.20) -16.92%,
          rgba(222, 195, 128, 0.12) 21.25%,
          rgba(249, 240, 178, 0.00) 53.82%,
          rgba(222, 195, 128, 0.00) 84.42%,
          rgba(219, 174, 76, 0.00) 114.82%
        )
      `,
                    WebkitMask:
                        "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
                    WebkitMaskComposite: "xor",
                    maskComposite: "exclude",
                    pointerEvents: "none",
                    transition: "background 0.35s ease",
                },

                /* 🔥 HOVER EFFECT */
                "&:hover::before": {
                    background:
                        "linear-gradient(90deg, #9E5E10 0%, #F8BC36 25%, #F8EB51 53.71%, #E89B02 78.37%, #874600 100%)",
                },

                "&:hover": {
                    transform: "translateY(-4px)",
                },
            }}
        >
            <Typography
                sx={{
                    fontSize: { xs: '26px', md: '35px' },
                    fontWeight: 700,
                    color: "#fff",
                }}
            >
                {count.toLocaleString()}
                {suffix}
            </Typography>

            <Divider sx={{ py: 0.5, borderColor: 'rgba(190, 190, 190, 0.28)' }} />

            <Typography
                sx={{
                    fontSize: 16,
                    color: "rgba(255, 255, 255, 0.70)",
                    mt: 2,
                }}
            >
                {label}
            </Typography>
        </Box>
    );
};

const steps = [
    {
        id: 1,
        title: "Create Your Account",
        desc:
            "Register securely, verify your details, and access a personalized dashboard designed to manage investments, monitor activity, and ensure account safety.",
        icon: SectionFiveIcon1,
        className: "card1",
    },
    {
        id: 2,
        title: "Start Your Investment",
        desc:
            "Deposit funds, get assigned trading pairs, and begin your investment journey with transparent tracking and professionally managed portfolio allocations.",
        icon: SectionFiveIcon2,
        className: "card2",
    },
    {
        id: 3,
        title: "Track Growth & Profits",
        desc:
            "Monitor daily profit updates, portfolio performance, trade history, and withdrawals in real time through a clear, user-friendly dashboard.",
        icon: SectionFiveIcon3,
        className: "card3",
    },
];

const sections = [
    {
        id: 0,
        title: "User Management Section",
        desc:
            "A simple, intuitive platform allowing users to track investments, view live crypto markets, monitor profits, manage portfolios, access support, and maintain full transparency across all activities.",
        image: SectionSixImg1,
    },
    {
        id: 1,
        title: "Admin Management Section",
        desc:
            "A clear and intuitive dashboard displaying invested assets, assigned trading pairs, daily profit updates, portfolio performance, transaction summaries, and real-time insights, giving users visibility in one centralized place.",
        image: SectionSixImg2,
    },
    {
        id: 2,
        title: "Support Section",
        desc:
            "Advanced security architecture ensuring protected access, two-factor authentication, device monitoring, controlled administrative actions, and transparent investment reporting to maintain trust, compliance, and long-term platform reliability.",
        image: SectionSixImg3,
    },
];

const faqData = [
    {
        question: "What is EMRT MARKETS?",
        answer:
            "EMRT MARKETS is a crypto investment platform that allows users to invest funds, track live market data, and monitor profits through a secure, admin-managed trading system.",
    },
    {
        question: "How does investing on EMRT MARKETS work?",
        answer:
            "Users deposit funds, and investments are professionally managed by administrators who assign trading pairs and apply profit calculations, while users track performance transparently.",
    },
    // {
    //     question: "Can I trade cryptocurrencies myself on this platform?",
    //     answer:
    //         "No. EMRT MARKETS operates as a managed investment platform. All trading pair assignments and profit updates are handled by the platform administrators.",
    // },
    {
        question: "Is my investment information secure?",
        answer:
            "Yes. The platform uses strong security measures including two-factor authentication, device monitoring, and controlled administrative access to protect user accounts and data.",
    },
    {
        question: "How do I track my profits?",
        answer:
            "All profits, trade history, deposits, and withdrawals are visible in real time within the user dashboard, providing full visibility into portfolio performance.",
    },
];

const cardSx = {
    position: "relative",
    background: "rgba(255,255,255,0.03)",
    borderRadius: "14px",
    p: { xs: 2, md: 2.5 },
    boxShadow: "0 10px 30px rgba(0,0,0,0.45)",
    overflow: "hidden",
    transition: "transform 0.25s ease",
    height: '-webkit-fill-available',
    marginTop: { xs: '10px', md: '50px' },
    "&::before": {
        content: '""',
        position: "absolute",
        inset: 0,
        padding: "1px",
        borderRadius: "14px",
        background: `
      linear-gradient(
        180deg,
        rgba(222, 182, 90, 0.06) 0%,
        rgba(255, 255, 255, 0.00) 100%
      ),
      linear-gradient(
        89deg,
        rgba(190, 153, 72, 0.20) -16.92%,
        rgba(222, 195, 128, 0.12) 21.25%,
        rgba(249, 240, 178, 0.00) 53.82%,
        rgba(222, 195, 128, 0.00) 84.42%,
        rgba(219, 174, 76, 0.00) 114.82%
      )
    `,
        WebkitMask:
            "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
        WebkitMaskComposite: "xor",
        maskComposite: "exclude",
        pointerEvents: "none",
        transition: "background 0.35s ease",
    },

    "&:hover::before": {
        background: `
    linear-gradient(
      180deg,
      rgba(222, 182, 90, 0.06) 0%,
      rgba(255, 255, 255, 0) 100%
    ),
    linear-gradient(
      100deg,
      #BE9948 6.31%,
      #DEC380 32.24%,
      #F9F0B2 54.35%,
      rgba(222, 195, 128, 0) 75.13%,
      rgba(219, 174, 76, 0.12) 95.78%
    )
  `,
    },

    "&:hover": {
        transform: "translateY(-4px)",
    },
};


const OuterHomePage = () => {
    const navigate = useNavigate();
    const [active, setActive] = useState(0);
    const [activeIndex, setActiveIndex] = useState(0);
    const handleToggle = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    //custom code

    const { assetsData, assetStatus } = useSelector(state => state.assets);
    const dispatch = useDispatch();
    const hasFetchedAsset = useRef(false);
    const [assetList, setAssetList] = useState([])
    const { tickers } = useBinanceAllTickers();

    const { isAuthenticated } = useSelector((state) => state.auth);

    useEffect(() => {
        if (!assetsData && !hasFetchedAsset.current) {
            const data = {
                'assetType': 'crypto'
            }
            dispatch(getAssetsNoauth(data));
            hasFetchedAsset.current = true
        }
    }, [dispatch, assetsData]);

    useEffect(() => {
        if (assetStatus == true) {
            setAssetList(assetsData);
        }
    }, [assetStatus])


    useEffect(() => {
        if (!tickers || tickers.length === 0) return;

        /* ================= SYMBOL NORMALIZER ================= */
        const normalizeToUSDT = (symbol) => {
            if (!symbol) return null;
            const s = symbol.toUpperCase();
            return s.endsWith("USDT") ? s : `${s}USDT`;
        };

        const getPrice = (map, symbol) => {
            if (!symbol) return null;
            return map[symbol] || map[normalizeToUSDT(symbol)] || null;
        };

        /* ================= CREATE PRICE MAP ================= */
        const priceMap = {};

        tickers.forEach(t => {
            priceMap[t.symbol.toUpperCase()] = {
                lastPrice: Number(t.lastPrice),
                livePrice: Number(t.lastPrice),
                change24h: Number(t.change24h),
                change1h: Number(t.change1h || 0),
                baseVolume24h: Number(t.volume24h),
                quoteVolume24h: Number(t.quoteVolume24h),
            };
        });

        /* ================= TOP GAINERS ================= */
        setAssetList(prev =>
            prev.map(item => {
                const updated = getPrice(priceMap, item.source);
                return updated
                    ? {
                        ...item,
                        lastPrice: updated.lastPrice,
                        chage24h: updated.change24h,
                    }
                    : item;
            })
        );








    }, [tickers]);
    return (
        <div className='outer-home-page-main'>
            <OuterPageHeader />
            <main>
                <section className='benner-section'>
                    <Container maxWidth="xl">
                        <Grid2 container spacing={2} sx={{ justifyContent: 'center', alignItems: "center", textAlign: "center", paddingTop: '120px' }}>
                            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 10 }}>
                                <GradientBadge
                                    icon={<CryptoClarityIcon />}
                                    label="Crypto Clarity"
                                    sx={{ mt: 2 }}
                                />

                                <Typography variant="h1" className="gold-color2" sx={{ fontSize: { xs: 35, md: 55 }, fontWeight: 700, maxWidth: '950px', margin: '10px auto' }}>
                                    Smart Crypto Investment Platform for Consistent Growth
                                </Typography>
                                <Typography variant="body1" className="gold-color3" sx={{ fontSize: { xs: "16px", md: '18px' }, maxWidth: '900px', margin: '20px auto' }}>
                                    Track live crypto markets in real time with precision. Invest
                                    confidently using secure, data-driven tools. Monitor daily
                                    profits effortlessly in one unified platform.
                                </Typography>
                                <Stack direction="row" spacing={2} sx={{ justifyContent: 'center', paddingTop: '20px', flexWrap: 'wrap', gap: '15px' }}>
                                    <div className="golden-btn">
                                        <Button onClick={() => navigate("/trade")}
                                            endIcon={<ButtonIcons1 />}
                                        >
                                            Get Started
                                        </Button>
                                    </div>

                                    <div className="golden-btn2">
                                        <Button onClick={() => isAuthenticated ? navigate('/portfolio') : navigate("/register")}
                                            endIcon={<ButtonIcons2 />}
                                        >
                                            View Dashboard
                                        </Button>
                                    </div>
                                </Stack>

                                {/* Features */}
                                <Stack direction="row" spacing={4} sx={{ justifyContent: 'center', paddingTop: '20px', flexWrap: 'wrap', gap: '15px' }}>
                                    {["Secure", "Transparent", "Profitable"].map((item) => (
                                        <Stack direction="row" spacing={1} alignItems="center" key={item}>
                                            <CheckIcons />
                                            <Typography sx={{ color: '#F2F2F2' }}>{item}</Typography>
                                        </Stack>
                                    ))}
                                </Stack>

                                <Box
                                    component="img"
                                    src={SectionBennerImg}
                                    alt='SectionBennerImg'
                                    sx={{
                                        width: { xs: "100%", md: '90%' },
                                        paddingTop: '50px'
                                    }}
                                />
                            </Grid2>
                        </Grid2>
                    </Container>
                </section>

                <section className="section-one">
                    <Box sx={{ textAlign: 'center', paddingTop: { xs: '40px', md: '60px' } }}>
                        <GradientBadge
                            icon={<CryptoClarityIcon />}
                            label="Top Listed"
                            sx={{ mt: 2 }}
                        />
                        <Typography variant="h2" sx={{ fontSize: { xs: 28, md: 42 }, fontWeight: 500, maxWidth: '950px', margin: '10px auto', color: '#fff' }}>
                            Top <span className="gold-color">Crypto coins </span> Updates
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            position: "relative",
                            overflow: "hidden",
                            width: "100%",
                            borderRadius: "12px",
                            paddingTop: '40px',
                            "@keyframes fadeSlide": {
                                from: {
                                    opacity: 0,
                                    transform: "translateY(10px)",
                                },
                                to: {
                                    opacity: 1,
                                    transform: "translateY(0)",
                                },
                            },
                            "@keyframes tickerMarquee": {
                                "0%": {
                                    transform: "translateX(0)",
                                },
                                "100%": {
                                    transform: "translateX(-50%)",
                                },
                            },

                            animation: "fadeSlide 0.8s ease forwards",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                gap: 3,
                                width: "max-content",
                                px: 2,
                                animation: "tickerMarquee 30s linear infinite",
                            }}
                        >
                            {assetList?.length > 0 && assetList.map((coin, index) => (
                                <Stack
                                    key={`${coin.source}-${index}`}
                                    direction="row"
                                    spacing={1.5}
                                    alignItems="center"
                                    sx={{
                                        px: 3,
                                        py: 2,
                                        borderRadius: "12px",
                                        background: 'transparent',
                                        border: "1px solid rgba(255,255,255,0.06)",
                                        minWidth: "fit-content",
                                        opacity: 0,
                                        animation: "fadeSlide 0.6s ease forwards",
                                        animationDelay: `${index * 0.1}s`,
                                    }}
                                >
                                    <Avatar
                                        src={process.env.REACT_APP_BACKEND_URL + coin.image}
                                        alt={coin.source}
                                        sx={{ width: 32, height: 32, background: 'rgba(247, 247, 247, 0.12)', padding: '8px', borderRadius: '16px' }}
                                    />

                                    <Box>
                                        <Typography
                                            sx={{
                                                color: "#fff",
                                                fontWeight: 600,
                                                fontSize: 18,
                                            }}
                                        >
                                            {coin.source}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                color: "#5D5C5D",
                                                fontSize: 14,
                                            }}
                                        >
                                            {coin.name}
                                        </Typography>
                                    </Box>

                                    <Box
                                        sx={{
                                            ml: 2,
                                            backgroundColor: parseFloat(coin.chage24h || 0) > 0 ? "rgba(0, 203, 106, 0.80)" : "red",
                                            borderRadius: '12px',
                                            padding: '5px 8px'
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#fff",
                                                fontSize: 14,
                                            }}
                                        >
                                            {/* {`↑ ${coin.chage24h}`} */}
                                            {(() => {
                                                const num = parseFloat(coin.chage24h || 0);
                                                if (num >= 1e12) return (num / 1e12).toFixed(4) + "T";
                                                if (num >= 1e9) return (num / 1e9).toFixed(4) + "B";
                                                if (num >= 1e6) return (num / 1e6).toFixed(4) + "M";
                                                if (num >= 1e3) return (num / 1e3).toFixed(4) + "K";
                                                return num.toFixed(4);
                                            })()}
                                        </Typography>
                                    </Box>
                                </Stack>
                            ))}
                        </Box>


                    </Box>
                </section>

                <section className='section-two' id="about-us-id" style={{ scrollMarginTop: "100px" }}>
                    <Container maxWidth="xl" >
                        <Grid2 container spacing={2} sx={{ pt: { xs: 4, md: 10 }, alignItems: { xs: 'center', md: 'start' }, justifyContent: 'center' }}>
                            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <Box sx={{ textAlign: 'center', paddingBottom: '50px' }}>
                                    <GradientBadge
                                        icon={<CryptoClarityIcon />}
                                        label="Crypto Clarity"
                                        sx={{ mt: 2 }}
                                    />
                                    <Typography variant="h2" sx={{ fontSize: { xs: 28, md: 42 }, fontWeight: 500, maxWidth: '950px', margin: '10px auto', color: '#fff' }}>
                                        About  <span className="gold-color">EMRT MARKETS </span>
                                    </Typography>
                                </Box>
                            </Grid2>
                            <Grid2 item size={{ xs: 12, sm: 8, md: 6, lg: 6, xl: 5 }} sx={{ textAlign: 'center' }}>
                                <Box
                                    component="img"
                                    src={SectionTwoImg}
                                    alt="secure asset"
                                    sx={{
                                        width: "90%",
                                    }}
                                />
                            </Grid2>

                            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 7 }}>
                                <Box
                                    sx={{
                                        padding: '10px 20px'
                                    }}
                                >
                                    <Stack spacing={3}>
                                        <Box sx={{ display: 'flex', gap: '20px' }}>
                                            <Box sx={{ width: '30px', paddingTop: '10px' }}>
                                                <CheckIcons2 />
                                            </Box>
                                            <Typography sx={{ color: "rgba(255, 255, 255, 0.70)", fontSize: { xs: '16px', md: '18px' }, lineHeight: 1.8, }}>

                                                <b>EMRT MARKETS</b> is a secure and transparent crypto investment
                                                platform designed to help users grow their digital assets with
                                                confidence. We combine live crypto market insights with professionally
                                                managed investment strategies, allowing users to track performance
                                                without the complexity of manual trading.
                                            </Typography>

                                        </Box>
                                        <Box sx={{ display: 'flex', gap: '20px' }}>
                                            <Box sx={{ width: '30px', paddingTop: '10px' }}>
                                                <CheckIcons2 />
                                            </Box>
                                            <Typography sx={{ color: "rgba(255, 255, 255, 0.70)", fontSize: { xs: '16px', md: '18px' }, lineHeight: 1.8 }}>

                                                At EMRT MARKETS, our mission is to deliver a simple, secure, and
                                                professional crypto investment experience backed by transparency and
                                                expert management.
                                            </Typography>
                                        </Box>
                                        <Stack direction="row" spacing={4} sx={{ justifyContent: 'start', paddingTop: '10px', flexWrap: 'wrap', paddingBottom: '20px', gap: '15px' }}>
                                            {["Secure", "Transparent", "Profitable"].map((item) => (
                                                <Stack direction="row" spacing={1} alignItems="center" key={item}>
                                                    <CheckIcons />
                                                    <Typography sx={{ color: '#F2F2F2' }}>{item}</Typography>
                                                </Stack>
                                            ))}
                                        </Stack>

                                        {/* Stats */}
                                        <Grid2 container spacing={2} mt={4} sx={{ justifyContent: 'center' }}>
                                            <Grid2 item size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 4 }}>
                                                <StatCard
                                                    value={5}
                                                    suffix="$ M+"
                                                    label="Total Investments Managed"
                                                />
                                            </Grid2>

                                            <Grid2 item size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 4 }}>
                                                <StatCard
                                                    value={10000}
                                                    suffix="+"
                                                    label="Registered Users"
                                                />
                                            </Grid2>

                                            <Grid2 item size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 4 }}>
                                                <StatCard
                                                    value={24}
                                                    suffix="/7"
                                                    label="Support System"
                                                />
                                            </Grid2>
                                        </Grid2>
                                    </Stack>
                                </Box>
                            </Grid2>
                        </Grid2>


                    </Container>
                </section>

                <section className="section-three" id="feature-id" style={{ scrollMarginTop: "100px" }}>
                    <Container maxWidth="xl">
                        <Grid2 container spacing={2} sx={{ pt: { xs: 4, md: 10 }, alignItems: 'start' }}>
                            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <Box sx={{ textAlign: 'center', paddingBottom: '50px' }}>
                                    <GradientBadge
                                        icon={<CryptoClarityIcon />}
                                        label="Features"
                                        sx={{ mt: 2 }}
                                    />
                                    <Typography variant="h2" sx={{ fontSize: { xs: 28, md: 42 }, fontWeight: 500, maxWidth: '950px', margin: '10px auto', color: '#fff' }}>
                                        Why Choose   <span className="gold-color"> EMRT MARKETS? </span>
                                    </Typography>
                                    <Typography variant="body1" className="gold-color3" sx={{ fontSize: { xs: "16px", md: '18px' }, maxWidth: '900px', margin: '20px auto' }}>
                                        Choose EMRT MARKETS for secure crypto investing with transparent profits, live market insights, professional management, and reliable platform security.
                                    </Typography>
                                </Box>
                            </Grid2>
                        </Grid2>
                        <Box
                            sx={{
                                position: "relative",
                                borderRadius: "18px",
                                p: { xs: 3, md: 5 },
                                background: "rgba(255,255,255,0.02)",
                                overflow: "hidden",

                                /* 🔥 Gradient Border */
                                "&::before": {
                                    content: '""',
                                    position: "absolute",
                                    inset: 0,
                                    padding: "1px",
                                    borderRadius: "18px",
                                    background: `
            linear-gradient(
              180deg,
              rgba(222, 182, 90, 0.06) 0%,
              rgba(255, 255, 255, 0.00) 100%
            ),
            linear-gradient(
              100deg,
              #BE9948 6.31%,
              #DEC380 32.24%,
              #F9F0B2 54.35%,
              rgba(222, 195, 128, 0.00) 75.13%,
              rgba(219, 174, 76, 0.12) 95.78%
            )
          `,
                                    WebkitMask:
                                        "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
                                    WebkitMaskComposite: "xor",
                                    maskComposite: "exclude",
                                    pointerEvents: "none",
                                },
                            }}
                        >
                            <Grid2 container
                                spacing={4}
                                alignItems="center"
                            // sx={{ position: "relative", zIndex: 1 }}
                            >
                                <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} sx={{ textAlign: 'center' }}>
                                    <Typography
                                        component="h3"
                                        sx={{
                                            fontSize: { xs: 24, md: 28 },
                                            fontWeight: 700,
                                            color: "#fff",
                                            mb: 2,
                                        }}
                                    >
                                        Secure Investment Platform
                                    </Typography>

                                    <Typography
                                        component="p"
                                        sx={{
                                            fontSize: { xs: '15px', md: '16px' },
                                            lineHeight: 1.8,
                                            color: "#b5b8bc",
                                            maxWidth: 480,
                                            margin: '20px auto'
                                        }}
                                    >
                                        Your funds and personal data are protected using advanced security
                                        systems, strict access controls, encrypted transactions, and
                                        professionally managed investment processes to ensure safety,
                                        reliability, and complete user confidence at all times.
                                    </Typography>
                                </Grid2>
                                <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>

                                    <Box
                                        component="img"
                                        src={SectionThreeImg}
                                        alt="Secure dashboard"
                                        sx={{
                                            width: "100%",
                                        }}
                                    />

                                </Grid2>


                            </Grid2>
                        </Box>

                        <Grid2 container
                            spacing={4} sx={{ marginTop: { xs: '30px', md: '0px' } }}>
                            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                                <Box sx={cardSx}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            mb: { xs: 5, md: 7 },
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={SectionThreeImg1}
                                            alt="Transparent Profit Dashboard"
                                            sx={{
                                                width: "100%",
                                                maxWidth: 720,
                                                borderRadius: "20px",
                                                boxShadow: "0 40px 100px rgba(0,0,0,0.85)",
                                            }}
                                        />
                                    </Box>

                                    <Box
                                        sx={{
                                            maxWidth: 760,
                                        }}
                                    >
                                        <Typography
                                            component="h3"
                                            sx={{
                                                fontSize: { xs: 24, md: 28 },
                                                fontWeight: 700,
                                                color: "#ffffff",
                                                mb: 2,
                                            }}
                                        >
                                            Transparent Profit System
                                        </Typography>

                                        <Typography
                                            component="p"
                                            sx={{
                                                fontSize: 15,
                                                lineHeight: 1.9,
                                                color: "rgba(255, 255, 255, 0.70)",
                                                maxWidth: 550
                                            }}
                                        >
                                            Track your investments, profits, and complete transaction history
                                            through a clear, real-time dashboard designed to provide accurate
                                            data, full transparency, and easy understanding of your portfolio
                                            performance at every stage.
                                        </Typography>
                                    </Box>

                                </Box>
                            </Grid2>
                            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                                <Box sx={cardSx}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            mb: { xs: 5, md: 7 },
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={SectionThreeImg2}
                                            alt="Professional Crypto Management"
                                            sx={{
                                                width: "100%",
                                                maxWidth: 720,
                                                borderRadius: "20px",
                                                boxShadow: "0 40px 100px rgba(0,0,0,0.85)",
                                            }}
                                        />
                                    </Box>

                                    <Box
                                        sx={{
                                            maxWidth: 760,
                                        }}
                                    >
                                        <Typography
                                            component="h3"
                                            sx={{
                                                fontSize: { xs: 24, md: 28 },
                                                fontWeight: 700,
                                                color: "#ffffff",
                                                mb: 2,
                                            }}
                                        >
                                            Professional Crypto Management
                                        </Typography>

                                        <Typography
                                            component="p"
                                            sx={{
                                                fontSize: 15,
                                                lineHeight: 1.9,
                                                color: "rgba(255, 255, 255, 0.70)",
                                                maxWidth: 550
                                            }}
                                        >
                                            Experienced administrators professionally manage all trades, investment strategies, and profit allocations using controlled processes and market analysis to deliver consistent performance, reliable growth, and stable investment outcomes for every user account.
                                        </Typography>
                                    </Box>

                                </Box>
                            </Grid2>
                        </Grid2>
                    </Container>
                </section>

                <section className="section-four">
                    <Container maxWidth="xl" sx={{ pt: { xs: 2, md: 6 } }}>
                        <Box
                            sx={{
                                borderRadius: "36px",
                                position: "relative",
                                overflow: "hidden",
                                margin: "40px 0px",
                                color: "#fff",
                                backgroundImage: `url(${SectionFourImg})`,
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }}
                        >
                            <Grid2 container spacing={3} alignItems="center">
                                <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ padding: { xs: '40px', md: '80px 60px', textAlign: 'center' } }}>
                                    <GradientBadge
                                        icon={<CryptoClarityIcon />}
                                        label="Crypto Clarity"
                                        textColor="#000"
                                        sx={{ mt: 2, color: '#000' }}
                                    />

                                    <Typography
                                        variant="h2"
                                        sx={{
                                            fontWeight: 700,
                                            mt: 1,
                                            fontSize: { xs: "1.5rem", sm: "40px" },
                                            color: '#121212'
                                        }}
                                    >
                                        Think better with Reflect
                                    </Typography>
                                    <Typography variant="body1" sx={{ fontSize: { xs: "16px", md: '18px' }, maxWidth: '900px', margin: '20px auto', color: '#121212' }}>
                                        Join EMRT MARKETS to experience a secure, transparent, and professionally managed crypto investment platform designed to help you track markets, monitor profits, and grow your digital assets confidently.
                                    </Typography>
                                    <Stack direction="row" spacing={2} sx={{ justifyContent: 'center', paddingTop: '20px', flexWrap: 'wrap', gap: '15px' }}>
                                        <div className="golden-btn">
                                            <Button onClick={() => navigate("/register")}
                                                endIcon={<ButtonIcons1 />}
                                            >
                                                Register Now
                                            </Button>
                                        </div>

                                        <div className="golden-btn2">
                                            <Button sx={{ color: '#121212 !important' }} onClick={() => navigate("/support")}
                                                endIcon={<ButtonIcons22 />}
                                            >
                                                Contact Support
                                            </Button>
                                        </div>
                                    </Stack>
                                </Grid2>
                            </Grid2>
                        </Box>
                    </Container>
                </section>

                <section className="section-five" id="how-it-works-id" style={{ scrollMarginTop: "100px" }}>
                    <Container maxWidth="xl">
                        <Grid2 container spacing={5} sx={{ pt: { xs: 4, md: 10 }, alignItems: 'start', justifyContent: 'center' }}>
                            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <Box sx={{ paddingBottom: '10px' }}>
                                    <GradientBadge
                                        icon={<CryptoClarityIcon />}
                                        label="3 Steps"
                                        sx={{ mt: 2 }}
                                    />
                                    <Typography variant="h2" sx={{ fontSize: { xs: 28, md: 42 }, fontWeight: 500, margin: '10px auto', color: '#fff' }}>
                                        How its  <span className="gold-color"> Works </span>
                                    </Typography>
                                    <Typography variant="body1" className="gold-color3" sx={{ fontSize: { xs: "16px", md: '18px' }, maxWidth: '600px', margin: '20px 0px' }}>
                                        Choose EMRT MARKETS for secure crypto investing with transparent profits, live market insights, professional management, and reliable platform security.
                                    </Typography>
                                </Box>
                            </Grid2>
                            {steps.map((step, index) => (
                                <Grid2 key={step.id} item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                                    <Box className={step.className}
                                        sx={{
                                            position: "relative",
                                            display: "grid",
                                            gridTemplateColumns: "1fr 40px",
                                            gap: 2,
                                            // py: 4,
                                        }}
                                    >
                                        <Box>
                                            <Typography
                                                sx={{
                                                    color: "#fff",
                                                    fontWeight: 600,
                                                    fontSize: 20,
                                                    mb: 1,
                                                }}
                                            >
                                                {step.title}
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color: "rgba(255,255,255,0.6)",
                                                    fontSize: 15,
                                                    lineHeight: 1.8,
                                                    mb: 2,
                                                    maxWidth: 350
                                                }}
                                            >
                                                {step.desc}
                                            </Typography>
                                            <Typography
                                                className="gold-color4"
                                                sx={{
                                                    fontSize: 120,
                                                    fontWeight: 700,
                                                    lineHeight: 1,
                                                    textAlign: "center",
                                                }}
                                            >
                                                {String(index + 1).padStart(2, "0")}
                                            </Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                position: "relative",
                                                display: "flex",
                                                justifyContent: "center",
                                                marginRight: '50px',

                                                "&::before": {
                                                    content: '""',
                                                    position: "absolute",
                                                    top: 0,
                                                    bottom: 0,
                                                    width: "2px",
                                                    background:
                                                        "repeating-linear-gradient(to bottom, #F8BC36 0 4px, transparent 4px 10px)",
                                                    opacity: 0.7,
                                                },
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: 0,
                                                    width: 15,
                                                    height: 15,
                                                    borderRadius: "50%",
                                                    background:
                                                        "linear-gradient(90deg, #9E5E10 0%, #F8BC36 25%, #F8EB51 53%, #E89B02 78%, #874600 100%)",
                                                    boxShadow: "inset 0 3px 3px rgba(0,0,0,0.25)",
                                                }}
                                            />
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    bottom: -10,
                                                    width: 60,
                                                    height: 60,
                                                    borderRadius: "50%",
                                                    background: "transparent",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    boxShadow: "inset 0 3px 3px rgba(0,0,0,0.25)",
                                                }}
                                            >
                                                <Box
                                                    component="img"
                                                    src={step.icon}
                                                    alt="step"
                                                    sx={{
                                                        width: 60,
                                                        height: 60,
                                                        objectFit: "contain",
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                    </Box>
                                </Grid2>
                            ))}
                        </Grid2>

                    </Container>
                </section>

                <section className="section-six" id="security-id" style={{ scrollMarginTop: "100px" }}>
                    <Container maxWidth="xl">
                        <Grid2 container spacing={2} sx={{ pt: { xs: 4, md: 10 }, alignItems: 'start' }}>
                            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <Box sx={{ textAlign: 'center', paddingBottom: '50px' }}>
                                    <GradientBadge
                                        icon={<CryptoClarityIcon />}
                                        label="Features"
                                        sx={{ mt: 2 }}
                                    />
                                    <Typography variant="h2" sx={{ fontSize: { xs: 28, md: 42 }, fontWeight: 500, maxWidth: '950px', margin: '10px auto', color: '#fff' }}>
                                        <span className="gold-color"> Security Section </span>
                                    </Typography>
                                    <Typography variant="body1" className="gold-color3" sx={{ fontSize: { xs: "16px", md: '18px' }, maxWidth: '900px', margin: '20px auto' }}>
                                        Choose EMRT MARKETS for secure crypto investing with transparent profits, live market insights, professional management, and reliable platform security.
                                    </Typography>
                                </Box>
                            </Grid2>

                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: { xs: "1fr", md: "1.2fr 1fr" },
                                    gap: { xs: 4, md: 10 },
                                    alignItems: "start",
                                    paddingBottom: '80px'
                                }}
                            >
                                <Stack spacing={2}>
                                    {sections.map((item, index) => (
                                        <Box
                                            key={item.id}
                                            onClick={() => setActive(index)}
                                            sx={{
                                                cursor: "pointer",
                                                p: 2,
                                                borderRadius: 2,
                                                transition: "all .3s ease",
                                                background:
                                                    active === index
                                                        ? "linear-gradient(90deg, rgba(219,174,76,0.18), rgba(0,0,0,0))"
                                                        : "transparent",
                                                borderLeft:
                                                    active === index
                                                        ? "3px solid #DBAE4C"
                                                        : "3px solid transparent",
                                            }}
                                        >
                                            <Typography className={active === index ? "gold-color" : ""}
                                                sx={{
                                                    color: active === index ? "#DBAE4C" : "#fff",
                                                    fontWeight: 600,
                                                    mb: 0.5,
                                                    fontSize: { xs: '20px', md: '26px' }
                                                }}
                                            >
                                                {item.title}
                                            </Typography>

                                            {active === index && (
                                                <>
                                                    <Typography
                                                        sx={{
                                                            color: "rgba(255, 255, 255, 0.70)",
                                                            fontSize: 16,
                                                            lineHeight: 1.8,
                                                            mt: 2,
                                                            maxWidth: 500
                                                        }}
                                                    >
                                                        {item.desc}
                                                    </Typography>
                              
                                                </>
                                            )}
                                        </Box>
                                    ))}
                                </Stack>
                                <Box
                                    sx={{
                                        position: "relative",
                                        borderRadius: 4,
                                        p: 2,
                                        background:
                                            "linear-gradient(180deg, rgba(255,255,255,0.05), rgba(0,0,0,0.9))",
                                        border: "1px solid rgba(219,174,76,0.4)",
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={sections[active].image}
                                        alt={sections[active].title}
                                        sx={{
                                            width: "100%",
                                            borderRadius: 3,
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Grid2>
                    </Container>
                </section>

                <section className="section-sevan" id="faq-id" style={{ scrollMarginTop: "100px" }}>
                    <Container maxWidth="xl">
                        <Grid2 container spacing={2} sx={{ pt: { xs: 4, md: 10 }, alignItems: 'center', paddingBottom: '80px' }}>
                            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 5, xl: 5 }}>
                                <Box sx={{ paddingBottom: '50px' }}>
                                    <FaqIcons />
                                    <Typography variant="h2" sx={{ fontSize: { xs: 28, md: 42 }, fontWeight: 500, maxWidth: '950px', margin: '10px auto', color: '#fff' }}>
                                        Frequently Asked  <span className="gold-color"> Questions </span>
                                    </Typography>
                                    <Typography variant="body1" className="gold-color3" sx={{ fontSize: { xs: "16px", md: '18px' }, maxWidth: '500px', margin: '20px 0px' }}>
                                        If the question is not available on our FAQ section, Feel free to contact us personally, we will resolve your respective doubts.
                                    </Typography>


                                </Box>
                            </Grid2>
                            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 7, xl: 7 }}>
                                <Stack spacing={2}>
                                    {faqData.map((item, index) => {
                                        const isActive = activeIndex === index;

                                        return (
                                            <Box
                                                key={index}
                                                onClick={() => handleToggle(index)}
                                                sx={{
                                                    cursor: "pointer",
                                                    borderRadius: "14px",
                                                    background: "rgba(255,255,255,0.03)",
                                                    border: "1px solid rgba(255,255,255,0.08)",
                                                    px: 3,
                                                    py: 2,
                                                    transition: "all 0.35s ease",
                                                    boxShadow: isActive
                                                        ? "0 0 0 1px rgba(219,174,76,0.6)"
                                                        : "none",
                                                }}
                                            >
                                                <Stack
                                                    direction="row"
                                                    alignItems="center"
                                                    justifyContent="space-between"
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontSize: 18,
                                                            fontWeight: 500,
                                                            color: "#fff",
                                                        }}
                                                    >
                                                        {item.question}
                                                    </Typography>

                                                    {isActive ? (
                                                        <RemoveIcon sx={{ color: "#DBAE4C" }} />
                                                    ) : (
                                                        <AddIcon sx={{ color: "#DBAE4C" }} />
                                                    )}
                                                </Stack>

                                                <Collapse in={isActive} timeout={300}>
                                                    <Typography
                                                        sx={{
                                                            mt: 3,
                                                            fontSize: 15,
                                                            lineHeight: 1.8,
                                                            color: "rgba(255,255,255,0.7)",
                                                            animation: "fadeSlide 0.4s ease",
                                                        }}
                                                    >
                                                        {item.answer}
                                                    </Typography>
                                                </Collapse>
                                            </Box>
                                        );
                                    })}

                                    <style>
                                        {`
          @keyframes fadeSlide {
            from {
              opacity: 0;
              transform: translateY(8px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
                                    </style>
                                </Stack>
                            </Grid2>
                        </Grid2>
                    </Container>
                </section>
            </main>
            <OuterPageFooter />
        </div>
    )
}



export default OuterHomePage